import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { PxMark } from "@/components/PxMark";

interface AuthGuardProps {
  children: ReactNode;
}

export function AuthGuard({ children }: AuthGuardProps) {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <PxMark state="thinking" size={24} />
      </div>
    );
  }

  if (!user) {
    // Pass only serializable data (pathname + search) to avoid DataCloneError
    const returnUrl = location.pathname + location.search;
    return <Navigate to="/auth" state={{ returnUrl }} replace />;
  }

  return <>{children}</>;
}
